import { CadenceViewModel } from 'cadence';

export interface ICadenceViewEvent<M = CadenceViewModel, D = any> {
  name: string;
  data?: D;
  view: M;
  from?: CadenceViewModel;
}
